export const latinRegexp = new RegExp("^[A-Za-z0-9 !@#$%^&*.]+$");
